import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<{quoteCount:number}, {quoteCount:number}>;

export const BeginLoadQuoteCount: HandlerType = props => {
    props.dispatch({
        type: "Custom/Quote/BeginLoadQuoteCount",
    });
};


export const CompletedLoadQuoteCount: HandlerType = props => {
    props.dispatch({
        type: "Custom/Quote/CompletedLoadQuoteCount",
        quoteCount: props.parameter.quoteCount,
    });
};

export const chain = [BeginLoadQuoteCount, CompletedLoadQuoteCount];

const quoteCountHandler = createHandlerChainRunner(chain, "quoteCountHandler");
export default quoteCountHandler;